/*
import React, { useEffect } from 'react';
import 'jsvectormap';
import 'jsvectormap/dist/maps/world.js';
import './WorldMapMarkers.css';

const WorldMapWithMarkers = ({markers}) => {
  useEffect(() => {
    const map = new window.jsVectorMap({
      selector: '#world-map',
      map: 'world',
      center: [90, 0],
      zoom: 1,
      markers: markers,
      markerStyle: {
        initial: { fill: '#003366' },
      },
      zoomOnScroll: false,
      
      onMarkerClick(index, event) {
        const clickedMarker = markers[event];
        if (clickedMarker && clickedMarker.link) {
          window.open(clickedMarker.link, '_blank'); // Apri il link in una nuova scheda
        } else {
          alert("Spiacenti. Si è verificato un errore nell'apertura del link")
        }
      },
    });

    return () => map.destroy(); // Cleanup quando il componente viene smontato
  }, [markers]);
  

  return <div id="world-map" style={{ height: '500px', overflowX: 'auto' }}></div>;
};

export default WorldMapWithMarkers;
*/













import React, { useEffect } from 'react';
import 'jsvectormap';
import 'jsvectormap/dist/maps/world.js';
import './WorldMapMarkers.css';

const WorldMapWithMarkers = ({markers}) => {
    
  useEffect(() => {
    const map = new window.jsVectorMap({
      selector: '#world-map',
      map: 'world',
      center: [90, 0],
      zoom: 1,
      markers: markers,
      markerStyle: {
        initial: { fill: '#003366' },
      },
      zoomOnScroll: false,
    });

  }, [markers]);

  return <div id="world-map" style={{ height: '500px', overflowX: 'auto' }}></div>;
};

export default WorldMapWithMarkers;